import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import { Form, Button, Col, Row, Spin, Input, Select } from "antd";
import axios from '../../utils/request';
import { Alert } from 'antd';

export class XdfOffer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            loginUser: "",
            commonParamater: "",
            dropDownUsers: [],
            userModel: { tenantId: 0, userId: 0, serachWord: "", pageIndex: 0, pageSize: 50 },
            applicantModel: { tenantId: 0, jobId: "", personId: "", applyId: "",userId:0 },
            applicantInfo: { JobCode: "", JobTitle: "", CadidateId: "", ApplyId: "", Name: "", Mobile: "", Gender: "", EducationLevel: "", Email: "", IsExcellentEducation: "", LoginUserEmail: ""}
        }
        this.onSearch = this.onSearch.bind(this);//手动绑定
    }
    componentDidMount() {
        document.title = '候选人信息推送EHR'
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        let tenantId = parseInt(urlParams.get("tenantId"));
        let userId = parseInt(urlParams.get("userId"));
        let jobId = urlParams.get("jobId");
        let personId = urlParams.get("personId");
        let applyId = urlParams.get("applyId");
        this.state.commonParamater = commonParamater;
        this.loadPage(commonParamater, tenantId, userId, jobId, personId, applyId);
    }

    loadPage = (commonParamater, tenantId, userId, jobId, personId, applyId) => {
        if (!commonParamater) {
            this.CheckApplicantWithUrlParams(tenantId, userId, jobId, personId,applyId);
            
        } else {
            this.CheckApplicant(commonParamater);
        }
    };

    CheckApplicant = (commonParamater) => {
        axios.post("/api/xdf/CheckApplicant",null,
            { params: { commonParamater: commonParamater}})
            .then(res => {
                if (res.status !== 200 || res.data.code !== "200") {
                    const errorMessages = res.data?.message ?? "系统出错，请联系管理员！";
                    console.log("CheckApplicant api error", errorMessages);
                    this.setState({ errorMessage: errorMessages, isLoading: false, isReady: true });
                }
                else {
                    this.state.userModel.tenantId = res.data.data.tenantId;
                    this.state.userModel.userId = res.data.data.userId;
                    let applicantModel = {};
                    applicantModel.tenantId = res.data.data.tenantId;
                    applicantModel.userId = res.data.data.userId;
                    applicantModel.jobId = res.data.data.jobId;
                    applicantModel.personId = res.data.data.personId;
                    applicantModel.applyId = res.data.data.applyId;
                    this.state.applicantModel = applicantModel;

                    let userModel = this.state.userModel;
                    const bodyStringEhrEmail = JSON.stringify(userModel);
                    this.GetEhrEmail(bodyStringEhrEmail);
                    this.GetApplicantInfo(res.data?.data, res.data.data.applyId);

                }

            }).catch(error => {
                const errorMessages = error?.response?.data?.errorMessages ?? ["系统出错，请联系管理员！"]
                console.log("CheckApplicant api error", errorMessages);
                const errorMessage = errorMessages[0]
                this.setState({ errorMessage, isLoading: false, isReady: true });
            })
            .finally();
    };
    CheckApplicantWithUrlParams = (tenantId, userId, jobId, personId, applyId) => {
        this.state.userModel.userId = userId;
        let applicantModel = {};
        applicantModel.tenantId = tenantId;
        applicantModel.userId = userId;
        applicantModel.jobId = jobId;
        applicantModel.personId = personId;
        applicantModel.applyId = applyId;
        this.state.applicantModel = applicantModel;

        let userModel = this.state.userModel;
        const bodyStringEhrEmail = JSON.stringify(userModel);
        this.GetEhrEmail(bodyStringEhrEmail);
        const bodyStringPerson = JSON.stringify(applicantModel)
        this.GetApplicantInfo(bodyStringPerson, applyId);
    };

    GetApplicantInfo = (bodyString, applyId) => {
        axios.post("/api/xdf/GetApplicantInfo",
            bodyString,
            {
                headers: { "Content-Type": "application/json" }
            })
            .then(res => {

                debugger;
                const isSuccess = res.data.isSuccess;
                if (isSuccess) {
                    const data = res.data.data;
                    let applicantInfo = {};
                    applicantInfo.LoginUserEmail = data.loginUserEmail;
                    applicantInfo.JobCode = data.jobCode;
                    applicantInfo.JobTitle = data.jobTitle;
                    applicantInfo.CadidateId = data.cadidateId;
                    applicantInfo.Name = data.name;
                    applicantInfo.Mobile = data.mobile;
                    applicantInfo.Gender = data.gender;
                    applicantInfo.EducationLevel = data.educationLevel;
                    applicantInfo.Email = data.email;
                    applicantInfo.IsExcellentEducation = data.isExcellentEducation;
                    applicantInfo.ApplyId = applyId;
                    this.setState({ isLoading: false, isReady: true, applicantInfo: applicantInfo });
                }
            })
            .catch(error => {
                debugger
                const errorMessages = error?.response?.data?.errorMessages ?? ["系统出错，请联系管理员！"]
                console.log("GetApplicantInfo api error", errorMessages);
                const errorMessage = errorMessages[0]
                this.setState({ errorMessage, isLoading: false, isReady: true });
                //window.location.href = "/no_permission";
            })
            .finally();
    };

    GetEhrEmail = (bodyString) => {
        axios.post("/api/xdf/GetEhrEmail",
            bodyString,
            {
                headers: { "Content-Type": "application/json" }
            })
            .then(res => {
                const isSuccess = res.data.isSuccess;
                if (isSuccess) {
                    const data = res.data.data;
                    let dropDownUsers = []
                    for (var i of data) {
                        let email = { id: i, name: i };
                        dropDownUsers.push(email);
                    };
                    this.setState({dropDownUsers: dropDownUsers });
                }
            })
            .catch(error => {
                debugger
                const errorMessages = error?.response?.data?.errorMessages ?? ["系统出错，请联系管理员"]
                console.log("GetEhrEmail api error", errorMessages);
                const errorMessage = errorMessages[0]
                this.setState({ errorMessage, isLoading: false, isReady: true });
                //window.location.href = "/no_permission";
            })
            .finally();
    };

    onSearch(val) {
        console.log('search:', val);
        let userModel = this.state.userModel;
        userModel.serachWord = val;
        userModel.pageIndex = 0;
        this.setState({ userModel: userModel})
        const bodyString = JSON.stringify(userModel);
        axios.post("/api/xdf/GetEhrEmail",
            bodyString,
            {
                headers: { "Content-Type": "application/json" }
            })
            .then(res => {
                const isSuccess = res.data.isSuccess;
                if (isSuccess) {
                    const data = res.data.data;
                    let dropDownUsers = []
                    for (var i of data) {
                        let email = { id: i, name: i };
                        dropDownUsers.push(email);
                    };

                    this.setState({ isLoading: false, isReady: true, dropDownUsers: dropDownUsers });
                }
            })
            .catch(error => {
                debugger
                console.log("GetEhrEmail api error", error);
                window.location.href = "/no_permission";
            })
            .finally();
    }

    onPopupScroll = (e) => {
        e.persist();
        const { target } = e;
        if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            let userModel = this.state.userModel;
            const scrollPage = userModel.pageIndex;
            const nextScrollPage = scrollPage + 1;
            console.log("nextScrollPage：" + nextScrollPage);
            this.setState({ userModel: userModel })
            userModel.pageIndex = nextScrollPage;
            const bodyString = JSON.stringify(userModel);
            axios.post("/api/xdf/GetEhrEmail",
                bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                })
                .then(res => {
                    const isSuccess = res.data.isSuccess;
                    if (isSuccess) {
                        const data = res.data.data;
                        let dropDownUsers = this.state.dropDownUsers;
                        for (var i of data) {
                            let email = { id: i, name: i };
                            dropDownUsers.push(email);
                        };

                        this.setState({ isLoading: false, isReady: true, dropDownUsers: dropDownUsers });
                    }
                })
                .catch(error => {
                    debugger
                    console.log("GetEhrEmail api error", error);
                    window.location.href = "/no_permission";
                })
                .finally();
        }
    }

    onEditApplicant = () => {
        debugger;
        const personId = this.state.applicantModel.personId;
        const jobId = this.state.applicantModel.jobId;
        const tenantId = this.state.applicantModel.tenantId;
        const userId = this.state.applicantModel.userId;
        const applyId = this.state.applicantModel.applyId;
        window.location.href = "/xdf-offer/edit-applicant?tenantId=" + tenantId + "&personId=" + personId + "&jobId=" + jobId + "&userId=" + userId + "&applyId=" + applyId;
    }

    onFinish = (values) => {
        values.tenantId = this.state.applicantModel.tenantId;
        values.personId = this.state.applicantModel.personId;
        values.jobId = this.state.applicantModel.jobId;
        values.applyId = this.state.applicantModel.applyId;

        this.LaunchEntryApproval(values);
    };

    LaunchEntryApproval = (values) => {
        axios.post("/api/xdf/LaunchEntryApproval",
            JSON.stringify(values),
            {
                headers: { "Content-Type": "application/json" }
            })
            .then(res => {
                debugger 
                const isSuccess = res.data.isSuccess;
                let errorMessage = "";
                console.log(res.data.data)
                if (!isSuccess) {
                    if (res.data.data != null && res.data.data !== '') {
                        errorMessage = res.data.data;
                    } else {
                        errorMessage = "流程创建失败"
                    }
                }
                else {
                    errorMessage = "流程创建成功"
                }
                this.setState({ errorMessage, isLoading: false, isReady: true });
            })
            .catch(error => {
                const errorMessages = error?.response?.data?.errorMessages ?? ["系统出错，请联系管理员！"]
                console.log("LaunchEntryApproval api error", errorMessages);
                const errorMessage = errorMessages[0]
                this.setState({ errorMessage, isLoading: false, isReady: true });
            })
            .finally();
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                if (this.state.errorMessage =="流程创建成功") {
                    return (<div style={{ textAlign: "center", padding: "32px", fontSize: "22px" }}><span style={{ color: "green" }}>{this.state.errorMessage}</span></div>)
                } else {

                    return (<div style={{ textAlign: "center", padding: "32px", fontSize: "22px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
                }
            } else {
                return (
                    <Spin size="large" spinning={this.state.isLoading}>
                        <div style={{ margin: "32px auto", maxWidth: "600px" }}>
                            <Form style={{ "paddingLeft": "5px", "paddingRight": "5px" }} onFinish={this.onFinish} labelCol={{ "span": 7 }} wrapperCol={{ "span": 19 }} initialValues={this.state.applicantInfo}>
                                <Row>
                                    <Col xs={{ "span": 24 }} md={{ "span": 24 }} lg={{ "span": 24 }}>
                                        <Form.Item label="EHR账号" name="LoginUserEmail"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "EHR账号为必填，请完善后再发起流程"
                                                },
                                                {
                                                    "message":"提示"
                                                }
                                            ]}>
                                            <Select
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                dropdownStyle={{ "maxHeight": 400, "overflow": 'auto' }}
                                                style={{ "width": '100%' }}
                                                onSearch={this.onSearch}
                                                onPopupScroll={this.onPopupScroll}>
                                                {
                                                    this.state.dropDownUsers.map(el => (
                                                        <Select.Option key={el.id}>{el.name}</Select.Option>
                                                    ))
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="职位编码" name="JobCode"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "职位编码为必填，请完善后再发起流程"
                                                }
                                            ]}>
                                            <Input readOnly={true} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="职位名称" name="JobTitle"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "职位名称为必填，请完善后再发起流程"
                                                }
                                            ]}>
                                            <Input readOnly={true}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="申请ID" name="ApplyId"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "申请ID为必填，请完善后再发起流程"
                                                }
                                            ]}>
                                            <Input readOnly={true}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="应聘者姓名" name="Name"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "应聘者姓名为必填，请完善后再发起流程"
                                                }
                                            ]}>
                                            <Input readOnly={true}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="手机号码" name="Mobile"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "手机号码为必填，请完善后再发起流程"
                                                }
                                            ]}>
                                            <Input readOnly={true}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="性别" name="Gender"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "性别为必填，请完善后再发起流程"
                                                }
                                            ]}>
                                            <Input readOnly={true}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="最高学历" name="EducationLevel" validateStatus="error"
                                            help="请核实最高学历与实际教育经历，若不一致请到教育经历中修改"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "最高学历为必填，请在应聘者详情页维护最高学历"
                                                }
                                            ]}>
                                            <Input readOnly={true}
                                                placeholder="最高学历为必填，请在应聘者详情页维护最高学历" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="个人邮箱" name="Email"
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "个人邮箱为必填，请完善后再发起流程"
                                                }
                                            ]}>
                                            <Input readOnly={true}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={{ span: 7, offset: 3  }} md={{ span: 7, offset: 3 }} lg={{ "span": 7, "offset": 3 }}>
                                        <Form.Item>
                                            <Button type="primary" className="float-left" onClick={this.onEditApplicant}>补充/编辑简历信息</Button>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={{ span: 7, offset: 7 }} md={{ span: 7, offset: 7 }} lg={{ "span": 7, "offset": 7 }}>
                                        <Form.Item>
                                            <Button type="primary" className="float-right" block htmlType="submit">推送至EHR</Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Spin>
                );
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}